import type { ChartGroup } from '@integratio/core';
import { formatPercent } from '../../lib/format';
import { IsoBlockChart, type IsoCell } from './IsoBlockChart';
import { IsoLegend } from './IsoLegend';

interface Props {
  groups: ChartGroup[];
  total: number;
  print?: boolean;
}

export function BehaviorChart({ groups, total, print = false }: Props): JSX.Element {
  const positioned = groups.filter((group) => group.matrix);
  const cells: IsoCell[] = positioned.map((group) => ({
    key: group.key,
    name: group.name,
    color: group.color,
    value: group.percentage,
    label: `${group.count}`,
    row: group.matrix!.row,
    col: group.matrix!.col,
    side: group.key === 'colaboracao' ? 'right' : undefined,
  }));

  return (
    <div className={print ? 'grid grid-cols-[300px_1fr] gap-6' : 'grid gap-8 xl:grid-cols-[300px_1fr]'}>
      <IsoLegend groups={groups} total={total} limit={print ? Infinity : 8} showNames={!print} />
      <div className="min-w-0">
        <IsoBlockChart
          cells={cells}
          rows={2}
          cols={2}
          axisLeft="Interesses"
          axisRight="Influência"
          width={1040}
          height={print ? 520 : 680}
          showExternalValues={false}
          showCellLabels={false}
          className="h-auto w-full"
        />
        <div className="mt-2 flex flex-wrap justify-center gap-x-6 gap-y-1 text-[11px] text-brand-slate">
          {positioned.map((group) => (
            <span key={group.key} className="flex items-center gap-1.5">
              <span className="h-2 w-2 rounded-full" style={{ backgroundColor: group.color }} aria-hidden />
              {group.name}: <strong className="text-brand-graphite">{formatPercent(group.percentage)}</strong>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
